export default __webpack_public_path__ + "static/media/D007_tn.e5e8a8d4.jpg";